module.exports = __webpack_public_path__ + "static/img/b6.0be7b68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b6.jpg
// module id = SdD/
// module chunks = 1